import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Flatpickr from "react-flatpickr";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import ReactSelect from "react-select";
import dateFormat from "dateformat";
// import Slider from "rc-slider";

const bonusDefaultOptions = [{
  label: 'Regular',
  value: 'Regular',
}, {
  label: 'Custom',
  value: 'Custom',
}]

const SalaryBonusModal = ({
  updateBonus,
  addBonus,
  isOpen,
  toggle,
  editData,
  permissions,
  positions,
  selectedFilter,
}) => {
  const [rangeDate, setRangeDate] = React.useState([
    editData?.date_from ? new Date(editData.date_from) : new Date(),
    editData?.date_to ? new Date(editData.date_to) : new Date(),
  ]);
  // const [selectedPositions, setSelectedPosition] = React.useState();
  const [selectedType, setSelectedType] = React.useState();
  // const [sliderData, setSliderData] = React.useState([100, 900]);
  // const [sum, setSum] = React.useState('');
  // const [sales, setSales] = React.useState("");

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      // setSliderData([
      //   (editData?.plan_progress_percent_from * 100).toFixed(1),
      //   (editData?.plan_progress_percent_to * 100).toFixed(1),
      // ]);
      // setSales((editData?.sales_percent * 100).toFixed(1));
      // let currentUser = positions.findIndex(i => i.label === editData.position);
      // setSelectedPosition(positions[currentUser]);
      let currentType = bonusDefaultOptions.findIndex(i => i.label === editData.type);
      setSelectedType(bonusDefaultOptions[currentType])
    } else {
      // setSliderData([100, 900]);
      // setSelectedPosition("");
      setSelectedType(bonusDefaultOptions[0])

      // if (selectedFilter !== null) {
      //   let idx = positions.findIndex(i => i.label === selectedFilter.label);
      //   setSelectedPosition(positions[idx]);
      // }
    }
  }, [isOpen]);

  const getPercents = num => {
    let per = num / 100;
    return parseFloat(per).toFixed(4);
  };

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {

      if (editData !== null) {
        updateBonus(editData.id, {
          type: selectedType.value,
          date_from: dateFormat(rangeDate[0], "yyyy-mm-dd"),
          date_to: dateFormat(rangeDate[1], "yyyy-mm-dd"),
          ...(params?.name && { name: params.name }),
          ...(selectedType.value === 'Regular' ? { sum: params.sum } : { sum: params.sum_custom }),
          ...(selectedType.value === 'Regular' && { percent: params.percent })
        })
        toggle();
      } else {
        addBonus({
          type: selectedType.value,
          date_from: dateFormat(rangeDate[0], "yyyy-mm-dd"),
          date_to: dateFormat(rangeDate[1], "yyyy-mm-dd"),
          ...(params?.name && { name: params.name }),
          ...(selectedType.value === 'Regular' ? { sum: params.sum } : { sum: params.sum_custom }),
          ...(selectedType.value === 'Regular' && { percent: params.percent })
        })
        toggle();
      }
    }
  };

  // const changeSliderData = arr => {
  //   setSliderData(arr);
  // };

  // const changeInputs = (i, val) => {
  //   let currentData = sliderData;
  //   currentData[i] = Number(val) || 0;
  //   setSliderData([currentData[0], currentData[1]]);
  // };

  // const validateRange = (value, ctx) => {
  //   if (sliderData[0] > ctx.plan_progress_percent_to) {
  //     return " ";
  //   } else if (sliderData[1] < ctx.plan_progress_percent_from) {
  //     return " ";
  //   } else {
  //     if (ctx.plan_progress_percent_from <= ctx.plan_progress_percent_to) {
  //       return true;
  //     }
  //   }
  // };

  return (
    <Modal isOpen={isOpen} size="sm" autoFocus centered toggle={toggle}>
      <AvForm onSubmit={handleValidOrderSubmit}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            {editData !== null ? "Edit" : "Add"} salary bonuses
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col sm>
              <FormGroup className="mb-3">
                <Label>Name</Label>
                <AvField
                  name="name"
                  type="text"
                  defaultValue={editData?.name || ''}
                  placeholder="Bonus name..."
                />
              </FormGroup>
            </Col>
            <Col sm={12}>
              <Col sm>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom02">Type</Label>
                  <ReactSelect
                    name="type"
                    // options={positions}
                    options={bonusDefaultOptions}
                    placeholder="Select type..."
                    value={selectedType}
                    onChange={setSelectedType}
                    classNamePrefix="select2-selection"
                    errorMessage="Type field is required!"
                    required
                  />
                </FormGroup>
              </Col>
              {selectedType?.value == 'Custom' ? (
                <>
                  <Col sm>
                    <FormGroup className="mb-3">
                      <Label>Sum</Label>
                      <AvField
                        name="sum_custom"
                        className="form-control"
                        type="number"
                        placeholder="Amount of bonus..."
                        errorMessage="Please, enter amount bonus"
                        id="validationCustom01"
                        defaultValue={editData?.sum || ''}
                        // onChange={setSum}
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm>
                    <div className="mt-2">
                      <Label>Date range</Label>
                      <Flatpickr
                        name="date"
                        className="form-control d-block"
                        value={rangeDate}
                        onChange={date => setRangeDate(date)}
                        style={{ backgroundColor: "white" }}
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                        }}
                      />
                    </div>
                  </Col>
                </>
              ) : (
                <Row>
                  <Col sm={6}>
                    <FormGroup className="mb-3">
                      <Label>Sum</Label>
                      <AvField
                        name="sum"
                        type="number"
                        defaultValue={editData?.sum || ''}
                        placeholder="Amount of bonus..."
                        errorMessage="Please, enter amount bonus"
                        validate={{
                          required: {
                            value: true,
                            // errorMessage: "Please, enter amount bonus",
                          },
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-3">
                      <Label>Percent %</Label>
                      <AvField
                        name="percent"
                        type="number"
                        defaultValue={editData?.percent || ''}
                        placeholder="Bonus percent..."
                        errorMessage="Please, enter bonus percent"
                        validate={{
                          required: {
                            value: true,
                          },
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm>
                    <div className="mt-2">
                      <Label>Date range</Label>
                      <Flatpickr
                        name="date"
                        className="form-control d-block"
                        value={rangeDate}
                        onChange={date => setRangeDate(date)}
                        style={{ backgroundColor: "white" }}
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                        }}
                      />
                    </div>
                  </Col>
                </Row>)}
              {/* <Col sm>
                <FormGroup className="mb-3">
                  <Label>Sales percent</Label>
                  <AvField
                    name="sales_percent"
                    type="number"
                    placeholder="Sales percent..."
                    errorMessage="This value is required"
                    value={sales}
                    onChange={e => setSales(e.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please, enter sales percent",
                      },
                    }}
                  />
                </FormGroup>
              </Col>
              <Row>
                <Label>Plan progress percent</Label>
              </Row>
              <Row className="justify-content-center">
                <Col mb={6}>
                  <FormGroup className="mb-3">
                    <AvField
                      value={sliderData[0]}
                      name="plan_progress_percent_from"
                      type="number"
                      errorMessage="This value is required"
                      onChange={e => changeInputs(0, e.target.value)}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Can't be empty",
                        },
                        max: {
                          value: 1000,
                          errorMessage: " ",
                        },
                        checkRange: validateRange,
                      }}
                    />
                  </FormGroup>
                </Col>
                <Tire>-</Tire>
                <Col mb={6}>
                  <FormGroup className="mb-3">
                    <AvField
                      value={sliderData[1]}
                      name="plan_progress_percent_to"
                      type="number"
                      errorMessage="This value is required"
                      onChange={e =>
                        changeInputs(1, parseFloat(e.target.value))
                      }
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Can't be empty",
                        },
                        max: {
                          value: 1000,
                          errorMessage: " ",
                        },
                        checkRange: validateRange,
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={12}>
                  <Slider
                    range
                    min={0}
                    max={1000}
                    step={0.5}
                    allowCross={false}
                    value={sliderData}
                    onChange={e => changeSliderData(e)}
                    railStyle={{ backgroundColor: "#ced4da" }}
                    trackStyle={{ backgroundColor: "#34c38f" }}
                    handleStyle={{
                      borderColor: "#34c38f",
                      backgroundColor: "#ced4da",
                    }}
                  />
                </Col>
              </Row> */}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_salarybonusmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

const Tire = styled.span`
  position: relative;
  width: 10px;
  vertical-align: middle;
  right: 4px;
  top: 8px;
`;

SalaryBonusModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  addBonus: PropTypes.func.isRequired,
  updateBonus: PropTypes.func.isRequired,
  positions: PropTypes.array.isRequired,
  editData: PropTypes.any,
  selectedFilter: PropTypes.any,
};

export default SalaryBonusModal;
